import {
  AbweichenderOrtGeschaeftsleitungAngabenComponent,
  AdresserfassungComponent,
  AllgemeineKapitalAngabenComponent,
  AnmeldungAbfuehrungUstComponent,
  AnteilseignerAngabenComponent,
  AnteilseignerFormComponent,
  AntragVersendenComponent,
  AtypischeStilleBeteiligungAngabenComponent,
  AuslandsadresseComponent,
  BankverbindungAngabeComponent,
  BankverbindungAngabenComponent,
  BankverbindungComponent,
  BeginnLohnzahlungenComponent,
  BeginnTaetigkeitAngabenComponent,
  BeginnTaetigkeitWjStammkapitalAngabenComponent,
  BetriebstaetteFormComponent,
  BetriebstaettenAngabenComponent,
  BetriebstaetteSpecialFormComponent,
  BezeichnungKgAngabenComponent,
  BisherigeAdresseComponent,
  BisherigeBetrieblicheVerhaeltnisseAngabenComponent,
  BisherigePersoenlicheVerhaeltnisseAngabenComponent,
  CardComponent,
  ConversionHintComponent,
  DatenUebernahmeComponent,
  EmailComponent,
  EmpfangsbevollmaechtigterAngabenComponent,
  EntwurfLoeschenComponent,
  FragebogenSendenComponent,
  EricResponseComponent,
  FestsetzungAngabenComponent,
  FestsetzungVorauszahlungAngabenComponent,
  FestsetzungVorauszahlungenComponent,
  FinanzamtAngabenComponent,
  FinanzamtComponent,
  FooterComponent,
  FreistellungsbescheinigungAngabenComponent,
  GesetzlicherVertreterAngabenComponent,
  GesetzlicherVertreterFormComponent,
  GewinnermittlungAngabenComponent,
  GewinnermittlungComponent,
  GrossempfaengeradresseComponent,
  GruendungsformAngabenComponent,
  GruendungsformComponent,
  GrundlageVorauszahlungenComponent,
  HandelsregistereintragAngabenComponent,
  HandelsregistereintragComponent,
  HoeheDerBeteiligungComponent,
  HoeheGrundStammkapitalAngabeComponent,
  InlandsadresseComponent,
  InternetComponent,
  JuristischePersonComponent,
  KoerperschaftssteuerComponent,
  KommunikationsmittelComponent,
  KonzernComponent,
  LaufendeNummerComponent,
  LoaderComponent,
  LohnsteuerAngabenComponent,
  KonzernAngabenComponent,
  LohnsteuerBetriebsstaetteComponent,
  LohnsteuerComponent,
  MarktplatzComponent,
  NachreichungAngabenComponent,
  NachreichungComponent,
  NavigationComponent,
  NotarAngabenComponent,
  OneStopShopAngabenComponent,
  OrgangesellschaftFormComponent,
  OrganschaftAngabenComponent,
  OrganschaftsverhaeltnisseAngabenComponent,
  OrganschaftsverhaeltnisseFormComponent,
  KapgAusOrganschaftsverhaeltnisseFormComponent,
  OrgantraegerComponent,
  OrgantraegerNatuerlichePersonComponent,
  OrgantraegerNichtNatuerlichePersonComponent,
  OrtDesSitzesComponent,
  PartnerschaftsAngabenComponent,
  PersonComponent,
  PersonenAngabenComponent,
  PersonenstammDatenComponent,
  PersonenstandComponent,
  PersonExtendedWeitereAngabenComponent,
  PersonTypComponent,
  PersonWeitereAngabenComponent,
  PlattformComponent,
  PostfachadresseComponent,
  SteueridentifikationComponent,
  SteuerlicheBeratungAngabenComponent,
  SteuernummerComponent,
  SwitchComponent,
  TaetigkeitAngabenComponent,
  TaetigkeitsartComponent,
  TelefonnummerComponent,
  UmsaetzeInternetAngabenComponent,
  InfluencerComponent,
  InternethandelInfluencerComponent,
  UmsaetzeInternetComponent,
  UmsatzsteuerAngabenComponent,
  UmsatzsteuerComponent,
  VoraussichtlicheLohnsteuerComponent,
  VortaetigkeitComponent,
  WirtschaftsIdComponent,
  WirtschatsjahrAngabenComponent
} from './component';
import {InfoOptionalStepComponent, OptionalWizardStepDirective} from '@common-ui-lib';
import {NgModule} from '@angular/core';
import {
  EricErrorNavService,
  FormBaseModule,
  TransformationModule,
  TranslationModule,
  ValidationModule
} from '@utils-lib';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatevMessageModule} from '@datev/ngx-ui-components';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ModalModule} from 'ngx-bootstrap/modal';
import {IConfig, NgxMaskModule} from 'ngx-mask';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {DatePickerComponent} from './component/date-picker/date-picker.component';
import {DE_LANG} from './i18n/de';
import {
  EntsprichtWohnanschriftComponent
} from './component/adressen/entsprichtWohnanschrift/entsprichtWohnanschrift.component';
import { AttachmentsComponent } from './component/attachments/attachments.component';
import { TruncatePipe } from './pipes/truncate.pipe';

export const options: () => Partial<IConfig> = () => ({validation: false});

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    FormBaseModule,
    ReactiveFormsModule,
    TranslationModule.forChild({
      deLang: DE_LANG
    }),
    DatevMessageModule,
    ValidationModule,
    TransformationModule,
    ModalModule.forRoot(),
    NgxMaskModule.forRoot(options),
    BsDatepickerModule.forRoot()
  ],
  declarations: [
    NavigationComponent,
    FooterComponent,
    PersonenstammDatenComponent,
    PersonenAngabenComponent,
    AdresserfassungComponent,
    InlandsadresseComponent,
    AuslandsadresseComponent,
    PostfachadresseComponent,
    EntsprichtWohnanschriftComponent,
    SwitchComponent,
    KommunikationsmittelComponent,
    TelefonnummerComponent,
    BankverbindungComponent,
    PersonenstandComponent,
    PersonComponent,
    BetriebstaettenAngabenComponent,
    SteueridentifikationComponent,
    SteuernummerComponent,
    WirtschaftsIdComponent,
    JuristischePersonComponent,
    GrossempfaengeradresseComponent,
    BetriebstaetteFormComponent,
    BetriebstaetteSpecialFormComponent,
    CardComponent,
    OrgangesellschaftFormComponent,
    DatenUebernahmeComponent,
    EricResponseComponent,
    FinanzamtComponent,
    EmailComponent,
    InternetComponent,
    AntragVersendenComponent,
    FinanzamtAngabenComponent,
    AbweichenderOrtGeschaeftsleitungAngabenComponent,
    EntwurfLoeschenComponent,
    FragebogenSendenComponent,
    TaetigkeitAngabenComponent,
    OneStopShopAngabenComponent,
    FreistellungsbescheinigungAngabenComponent,
    EmpfangsbevollmaechtigterAngabenComponent,
    SteuerlicheBeratungAngabenComponent,
    BankverbindungAngabenComponent,
    BankverbindungAngabeComponent,
    UmsaetzeInternetAngabenComponent,
    InternethandelInfluencerComponent,
    InfluencerComponent,
    UmsaetzeInternetComponent,
    MarktplatzComponent,
    PlattformComponent,
    HandelsregistereintragAngabenComponent,
    HandelsregistereintragComponent,
    UmsatzsteuerAngabenComponent,
    AnmeldungAbfuehrungUstComponent,
    OrganschaftAngabenComponent,
    GewinnermittlungAngabenComponent,
    GewinnermittlungComponent,
    LohnsteuerComponent,
    LohnsteuerAngabenComponent,
    KonzernAngabenComponent,
    GruendungsformAngabenComponent,
    GruendungsformComponent,
    NachreichungAngabenComponent,
    NachreichungComponent,
    LohnsteuerBetriebsstaetteComponent,
    BeginnLohnzahlungenComponent,
    KonzernComponent,
    VoraussichtlicheLohnsteuerComponent,
    PersonWeitereAngabenComponent,
    PartnerschaftsAngabenComponent,
    BisherigeAdresseComponent,
    BisherigePersoenlicheVerhaeltnisseAngabenComponent,
    BisherigeBetrieblicheVerhaeltnisseAngabenComponent,
    VortaetigkeitComponent,
    FestsetzungVorauszahlungAngabenComponent,
    GrundlageVorauszahlungenComponent,
    GesetzlicherVertreterFormComponent,
    GesetzlicherVertreterAngabenComponent,
    OrtDesSitzesComponent,
    PersonExtendedWeitereAngabenComponent,
    InfoOptionalStepComponent,
    OptionalWizardStepDirective,
    TaetigkeitsartComponent,
    AllgemeineKapitalAngabenComponent,
    AnteilseignerAngabenComponent,
    LaufendeNummerComponent,
    HoeheDerBeteiligungComponent,
    AnteilseignerFormComponent,
    NotarAngabenComponent,
    BeginnTaetigkeitWjStammkapitalAngabenComponent,
    BeginnTaetigkeitAngabenComponent,
    WirtschatsjahrAngabenComponent,
    HoeheGrundStammkapitalAngabeComponent,
    KoerperschaftssteuerComponent,
    OrganschaftsverhaeltnisseFormComponent,
    KapgAusOrganschaftsverhaeltnisseFormComponent,
    OrgantraegerComponent,
    OrgantraegerNatuerlichePersonComponent,
    OrgantraegerNichtNatuerlichePersonComponent,
    OrganschaftsverhaeltnisseAngabenComponent,
    UmsatzsteuerComponent,
    BezeichnungKgAngabenComponent,
    AtypischeStilleBeteiligungAngabenComponent,
    FestsetzungAngabenComponent,
    FestsetzungVorauszahlungenComponent,
    ConversionHintComponent,
    PersonTypComponent,
    LoaderComponent,
    DatePickerComponent,
    AttachmentsComponent,
    TruncatePipe
  ],
  exports: [
    AnmeldungAbfuehrungUstComponent,
    NavigationComponent,
    FooterComponent,
    PersonenstammDatenComponent,
    PersonenAngabenComponent,
    AdresserfassungComponent,
    InlandsadresseComponent,
    AuslandsadresseComponent,
    PostfachadresseComponent,
    EntsprichtWohnanschriftComponent,
    SwitchComponent,
    KommunikationsmittelComponent,
    BankverbindungComponent,
    PersonenstandComponent,
    PersonComponent,
    SteueridentifikationComponent,
    JuristischePersonComponent,
    SteuernummerComponent,
    WirtschaftsIdComponent,
    ValidationModule,
    GrossempfaengeradresseComponent,
    BetriebstaettenAngabenComponent,
    BetriebstaetteFormComponent,
    BetriebstaetteSpecialFormComponent,
    CardComponent,
    OrgangesellschaftFormComponent,
    DatenUebernahmeComponent,
    EricResponseComponent,
    FinanzamtComponent,
    EmailComponent,
    InternetComponent,
    AntragVersendenComponent,
    FinanzamtAngabenComponent,
    AbweichenderOrtGeschaeftsleitungAngabenComponent,
    EntwurfLoeschenComponent,
    FragebogenSendenComponent,
    TaetigkeitAngabenComponent,
    OneStopShopAngabenComponent,
    EmpfangsbevollmaechtigterAngabenComponent,
    SteuerlicheBeratungAngabenComponent,
    FreistellungsbescheinigungAngabenComponent,
    UmsaetzeInternetAngabenComponent,
    InternethandelInfluencerComponent,
    InfluencerComponent,
    PlattformComponent,
    HandelsregistereintragAngabenComponent,
    HandelsregistereintragComponent,
    OrganschaftAngabenComponent,
    GewinnermittlungAngabenComponent,
    GewinnermittlungComponent,
    LohnsteuerAngabenComponent,
    GruendungsformAngabenComponent,
    NachreichungAngabenComponent,
    NachreichungComponent,
    LohnsteuerBetriebsstaetteComponent,
    BeginnLohnzahlungenComponent,
    KonzernComponent,
    VoraussichtlicheLohnsteuerComponent,
    PersonWeitereAngabenComponent,
    PartnerschaftsAngabenComponent,
    BisherigePersoenlicheVerhaeltnisseAngabenComponent,
    BisherigeBetrieblicheVerhaeltnisseAngabenComponent,
    FestsetzungVorauszahlungAngabenComponent,
    GesetzlicherVertreterAngabenComponent,
    OrtDesSitzesComponent,
    OptionalWizardStepDirective,
    PersonExtendedWeitereAngabenComponent,
    TaetigkeitsartComponent,
    AllgemeineKapitalAngabenComponent,
    AnteilseignerAngabenComponent,
    NotarAngabenComponent,
    BeginnTaetigkeitWjStammkapitalAngabenComponent,
    BeginnTaetigkeitAngabenComponent,
    WirtschatsjahrAngabenComponent,
    OrganschaftsverhaeltnisseAngabenComponent,
    BezeichnungKgAngabenComponent,
    AtypischeStilleBeteiligungAngabenComponent,
    FestsetzungAngabenComponent,
    LoaderComponent,
    DatePickerComponent
  ],
  providers: [
    EricErrorNavService
  ]
})
export class SharedModule {
}
